import Modal from '@components/v2/ui/Modal/Modal';
import { useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { PackQuantitiesWithMultiplier } from '../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import useGeneralSettingsStore from '../../../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import configureGridItemWidth from '../../../../../../../../utils/configureGridItemsWidth';
import useOrderProductGridContext from '../../../contexts/OrderProductGrid.context';
import useOrderProductPacksMenu from '../hooks/useOrderProductPacksMenu';
import { usePackStyles } from '../styles/usePackStyles';
import { OrderProductPacksMenuProps } from '../types/orderProductPacksMenu.types';
import {
  isPackSelected,
  isPackWithError,
  isPackWithUnavailableStock,
} from '../utils/orderProductPacksMenu.utils';
import PacksMenuHeader from './header/PacksMenuHeader';
import PacksMenuItem from './item/components/PacksMenuItem';
import PacksMenuLoading from './loading/PacksMenuLoading';

const OrderProductPacksMenu = ({ open, handleClose }: OrderProductPacksMenuProps) => {
  const { classes: packStyles } = usePackStyles();
  const [bodyElement, setBodyElement] = useState<HTMLDivElement | null>(null);
  const { readMode, packsWithError, packsWithUnavailableStock } = useOrderProductGridContext();

  const {
    options,
    onSearch,
    loadMore,
    isLoading,
    onClickRow,
    selectedData,
    onClickGridMultiply,
    isLoadingInitialValues,
  } = useOrderProductPacksMenu();

  const {
    generalSettings: { gridSize },
  } = useGeneralSettingsStore();

  const gridItemWidth = configureGridItemWidth(gridSize);

  const renderPackMenuItem = (pack: PackQuantitiesWithMultiplier) => {
    const packSelected = isPackSelected(selectedData, pack);
    const packWithError = isPackWithError(packsWithError, pack);
    const packWithUnavailableStock = isPackWithUnavailableStock(packsWithUnavailableStock, pack);
    const newSelected = selectedData.newItems.find((newItem) => newItem.id === pack.id);
    const packWithCorrectMultiplier = newSelected || pack;

    return (
      <PacksMenuItem
        itemWidth={gridItemWidth}
        isPackWithError={packWithError}
        isPackSelected={packSelected || readMode}
        isPackWithUnavailableStock={packWithUnavailableStock}
        pack={{ ...pack, multiplier: packWithCorrectMultiplier.multiplier }}
        onClickRow={(multiplier) => onClickRow(pack, packSelected, multiplier)}
        onClickGridMultiply={(multiplier) => onClickGridMultiply(pack, packSelected, multiplier)}
      />
    );
  };

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      size="registration"
      bodyRef={setBodyElement}
      header={{ title: LangEnum.GLOBAL_PACKS }}
      slots={{
        headerBottom: <PacksMenuHeader onSearch={onSearch} readMode={readMode} />,
      }}
    >
      {(isLoading || isLoadingInitialValues) && <PacksMenuLoading />}
      {!isLoading && (
        <Virtuoso
          data={options}
          endReached={loadMore}
          customScrollParent={bodyElement ?? undefined}
          className={packStyles.virtuoso}
          itemContent={(_, pack) => renderPackMenuItem(pack)}
        />
      )}
    </Modal>
  );
};

export default OrderProductPacksMenu;
